<template>
  <div id="app" class="twui-page" v-bottom="0">
    <!-- <div class="twui-doccenter xnew" :style="{ 'min-height':minHeight }"> -->
      <div class="twui-doccenter xnew" >
      <!--一级导航-->
      <tw-header @signin="dialogLogin = true" @signup="dialogLoginIn = true"></tw-header>
      <!--/一级导航-->
      <!-- 主体 -->
      <div class="twui-body">
        <div class="twui-body-inner">
          <component :is="$store.state.pageName"></component>
        </div>
      </div>
      <!-- /主体 -->
      <!-- 页脚 -->
      <tw-footer></tw-footer>
      <!-- /页脚 -->

      <!-- 右侧边栏 -->
      <div class="twui-rightside">
        <tw-totop></tw-totop>
      </div>
      <!-- /右侧边栏 -->

      <!-- 弹窗:登录 -->
      <el-dialog class="twui-login" title="天闻ECO云开放平台登录" :visible.sync="dialogLogin" size="tiny" :close-on-click-modal="false">
        <el-form>
          <el-form-item>
            <i class="ico ico-login-user"></i>
            <el-input auto-complete="off" placeholder="请输入登录帐号或邮箱"></el-input>
          </el-form-item>
          <el-form-item>
            <i class="ico ico-login-pwd"></i>
            <el-input auto-complete="off" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <i class="ico ico-login-org"></i>
            <el-select v-model="org" placeholder="请选择机构">
              <el-option v-for="item in orgList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input class="twui-login-code" auto-complete="off" style="width:120px;" placeholder="请输入验证码"></el-input>
            <img src="/static/dev/images/code.png" />
            <a>&nbsp;&nbsp;换一换</a>
          </el-form-item>
          <el-form-item class="twui-login-remember">
            <el-checkbox>下次自动登录</el-checkbox>
            <router-link to="/find_password">忘记密码</router-link>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <button class="twui-btn xmain xxlarge xfull" @click="dialogLogin = false">登录</button>
        </div>
      </el-dialog>
      <!-- /弹窗:登录 -->

      <!-- 弹窗:注册 -->
      <el-dialog class="twui-loginin" title="注册—请选择你的身份" :visible.sync="dialogLoginIn" size="tiny" :close-on-click-modal="false">
        <div class="twui-grid xpc-x5">
          <div class="twui-grid-col">
            <div class="twui-loginuser">
              <img class="twui-loginuser-img" src="/static/dev/images/view/teacher.png" />
              <div class="twui-loginuser-name">我是老师</div>
              <div class="twui-loginuser-footer">
                <router-link class="twui-btn xborder xlarge" to="/signup">注册</router-link>
              </div>
            </div>
          </div>
          <div class="twui-grid-col">
            <div class="twui-loginuser">
              <img class="twui-loginuser-img" src="/static/dev/images/view/student.png" />
              <div class="twui-loginuser-name">我是学生</div>
              <div class="twui-loginuser-footer">
                <router-link class="twui-btn xborder xlarge" to="/signup">注册</router-link>
              </div>
            </div>
          </div>
          <div class="twui-grid-col">
            <div class="twui-loginuser">
              <img class="twui-loginuser-img" src="/static/dev/images/view/school.png" />
              <div class="twui-loginuser-name">我是学校管理员</div>
              <div class="twui-loginuser-footer">
                <router-link class="twui-btn xborder xlarge" to="/signup">注册</router-link>
              </div>
            </div>
          </div>
          <div class="twui-grid-col">
            <div class="twui-loginuser">
              <img class="twui-loginuser-img" src="/static/dev/images/view/region.png" />
              <div class="twui-loginuser-name">我是区域管理员</div>
              <div class="twui-loginuser-footer">
                <router-link class="twui-btn xborder xlarge" to="/signup">注册</router-link>
              </div>
            </div>
          </div>
          <div class="twui-grid-col">
            <div class="twui-loginuser">
              <img class="twui-loginuser-img" src="/static/dev/images/view/dev.png" />
              <div class="twui-loginuser-name">我是应用开发者</div>
              <div class="twui-loginuser-footer">
                <router-link class="twui-btn xborder xlarge" to="/signup">注册</router-link>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- /弹窗:注册 -->
    </div>
  </div>
</template>

<script>
import Doc from './components/tw-doc'
import twDocSearch from '@/web/doc/search'
import dicMenu from '@/web/doc/document-menu'
// import URL from '../static/tools/baseurl'
export default {
  name: 'app',
  data () {
    return {
      pageName: this.$store.state.pageName,
      minHeight: 0,
      dialogLogin: false,
      dialogLoginIn: false,
      org: '',
      orgList: [
        {
          value: '001',
          label: '机构1'
        },
        {
          value: '选项002',
          label: '机构2'
        }
      ]
    }
  },
  components: {
    Doc,
    twDocSearch,
    dicMenu
  },
  mounted: function () {
    this.minHeight = window.innerHeight - 120 + 'px'
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?38aa1500